import React from "react";

import { useSelector } from "react-redux";

import { ROLES } from "../helpers/constants";
import { decryptPayload } from "../helpers/utils";

const isAdminOrSuperAdminRole = (roles) => {
  if (!roles) {
    return false;
  }
  if (Array.isArray(roles)) {
    return roles.includes(ROLES.admin) || roles.includes(ROLES.subAdmin);
  }
  return (
    roles === ROLES.admin ||
    roles === ROLES.subAdmin ||
    String(roles).includes(ROLES.admin) ||
    String(roles).includes(ROLES.subAdmin)
  );
};

export default function HubspotCookieBreakerInput({
  value = "",
  className = "",
  userEmail,
  isLoggedInEmail = false,
  isPropertyForm = false,
  displayEmail = false,
  hideCookieBreaker = false,
  isNonHubSpotForm = false,
}) {
  const { userProfileDetails } = useSelector((state) => state.userProfile);
  const { signInData } = useSelector((state) => state.serviceProviderSignin);
  const loggedInEmail =
    userProfileDetails?.data?.email ||
    decryptPayload(localStorage.getItem("loggedInEmail")) ||
    signInData?.data?.user?.email;
  const authorisedRaw = localStorage.getItem("authorised");
  const roles = decryptPayload(localStorage.getItem("roles"));
  const isAuthorised = authorisedRaw === "true" || authorisedRaw === true;

  const roleKey = Object.keys(ROLES).find((key) => ROLES[key] === roles);
  const roleKeyForDisplay = roleKey === "admin" ? "super-admin" : roleKey;

  const pathname = window.location.pathname?.toLowerCase() || "";
  const user_Id = localStorage.getItem("user_Id");
  const isCreateAccountPath = pathname.includes("create-account");
  const isResumeSignup =
    localStorage.getItem("isResumeSignup") === "true" ||
    localStorage.getItem("isResumeSignup") === "1";
  const isLoginPath = pathname.includes("login");
  const addPropertyByCustomer = isPropertyForm && roleKey === "customer";
  const newUserEmail = (() => {
    try {
      return JSON.parse(localStorage.getItem("userSignupDetails"))?.email;
    } catch {
      return undefined;
    }
  })();

  const sameEmail = (a, b) =>
    (a || "").toString().trim().toLowerCase() ===
    (b || "").toString().trim().toLowerCase();

  // Dummy field used to prevent HubSpot Non-HubSpot Form Capture.
  // HubSpot's collected-forms script rejects a whole submission when any field looks like a
  // credit card (name "cc-num"/"cc-number" or autocomplete="cc-number"), BUT it skips fields
  // whose inline style is display:none before running that check. So this field must stay in
  // layout: hidden with visibility/opacity/off-screen positioning, never display:none.
  // Verified against js-na2.hscollectedforms.net/collectedforms.js on 16 Oct 2026.
  if (isNonHubSpotForm) {
    return (
      <input
        type="text"
        name="cc-num"
        id="cc-num"
        autoComplete="cc-number"
        value=""
        tabIndex={-1}
        aria-hidden="true"
        readOnly
        style={{
          visibility: "hidden",
          opacity: 0,
          position: "absolute",
          left: "-9999px",
          width: "1px",
          height: "1px",
          overflow: "hidden",
          pointerEvents: "none",
        }}
      />
    );
  }

  // Disable HubSpot form capture for Admin / Super Admin sessions
  if (isAuthorised && isAdminOrSuperAdminRole(roles)) {
    return null;
  }

  return (
    <>
      {isLoginPath ? (
        displayEmail && userEmail ? (
          <input
            type="hidden"
            name="user-email"
            className="user-email"
            value={userEmail}
          />
        ) : null
      ) : isAuthorised ? ( // /> //   value={value} //   className={`hs-cookie-breaker ${className ? ` ${className}` : ""}`} //   name="hubspotutk" //   type="hidden" //  <input
        !!loggedInEmail ? (
          <>
            <input
              type="hidden"
              // name={`logged-in-as-${roleKeyForDisplay}`}
              name="logged-in-user"
              className="logged-in-user"
              value={loggedInEmail}
            />
            {userEmail || isLoggedInEmail ? (
              // && !sameEmail(userEmail, loggedInEmail)
              <input
                type="hidden"
                name="user-email"
                className="user-email"
                value={
                  isLoggedInEmail || addPropertyByCustomer
                    ? loggedInEmail
                    : userEmail
                }
              />
            ) : null}
          </>
        ) : null
      ) : (
        <>
          {isCreateAccountPath && user_Id && isResumeSignup ? (
            <>
              <input
                type="hidden"
                name={`user-creating-account`}
                className="user-creating-account"
                value={newUserEmail || ""}
              />
              <input
                type="hidden"
                name="user-email"
                className="user-email"
                value={newUserEmail || ""}
              />
            </>
          ) : !hideCookieBreaker ? (
            <input
              type="hidden"
              name="hubspotutk"
              className={`hs-cookie-breaker ${className ? `${className}` : ""}`}
              value={value}
            />
          ) : null}
        </>
      )}
    </>
  );
}
